import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { addDepositToOtherStart } from '../../../store/redux-slices/tenants'
import { updateWelcomeBonusStart } from '../../../store/redux-slices/superAdminSettings'

const useManageBonusVariant
 = ({ isTenant }) => {
  const dispatch = useDispatch()
  const { userId } = useParams()

  const deposit = (data) => {
    console.log('hiiiiiiii',data);
            dispatch(updateWelcomeBonusStart({
              bonusTimes:data.bonusTimes.toString(),
              userId: userId
            }))
  }

  return {
    deposit
  }
}

export default useManageBonusVariant

